import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  connect() {
  }

  select(e) {
    let themeClassEl = e.currentTarget.closest('[data-theme-class-id]')
    if (themeClassEl) {
      this.scrollToThemeClass(themeClassEl)
    }
  }

  scrollToThemeClass(el){
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
